import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Wybór między ratami równymi a malejącymi to jedna z najważniejszych decyzji przy zaciąganiu kredytu
        hipotecznego. Obie opcje mają swoje zalety i wady, a różnica w całkowitym koszcie kredytu może
        sięgać nawet kilkudziesięciu tysięcy złotych.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Czym są raty równe?</h2>
      <p>
        Raty równe (annuitetowe) to najpopularniejszy sposób spłaty kredytu hipotecznego w Polsce.
        Każdego miesiąca płacisz dokładnie tę samą kwotę przez cały okres kredytowania. Na początku
        większą część raty stanowią odsetki, a z czasem rośnie udział kapitału.
      </p>
      <p className="mt-3">
        <strong>Zalety:</strong> Stała, przewidywalna rata ułatwia planowanie budżetu domowego.
        Niższa rata na początku oznacza wyższą <BlogLink slug="jak-obliczyc-zdolnosc-kredytowa">zdolność kredytową</BlogLink>.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Czym są raty malejące?</h2>
      <p>
        W ratach malejących część kapitałowa jest stała (kwota kredytu podzielona przez liczbę rat),
        a odsetki naliczane są od zmniejszającego się salda. Pierwsza rata jest najwyższa,
        a każda kolejna nieco niższa.
      </p>
      <p className="mt-3">
        <strong>Zalety:</strong> Płacisz mniej odsetek w całym okresie kredytowania. Im dłużej spłacasz,
        tym lżejszy staje się ciężar raty.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Porównanie na konkretnym przykładzie</h2>
      <p>
        Dla kredytu o wartości 400 000 zł na 25 lat przy <BlogLink slug="co-to-jest-wibor">oprocentowaniu 7,85%</BlogLink>:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Raty równe:</strong> rata wynosi ok. 3 048 zł przez cały okres. Suma odsetek: ok. 514 000 zł.</li>
        <li><strong>Raty malejące:</strong> pierwsza rata ok. 3 950 zł, ostatnia ok. 1 342 zł. Suma odsetek: ok. 394 000 zł.</li>
        <li><strong>Oszczędność:</strong> wybierając raty malejące, zaoszczędzisz ok. 120 000 zł na odsetkach!</li>
      </ul>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20} loanYears={25} installmentType="decreasing" section="installment-type">
          Sprawdź różnicę w kalkulatorze RatyGo
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Która opcja jest lepsza dla Ciebie?</h2>
      <p>
        <strong>Wybierz raty równe, jeśli:</strong>
      </p>
      <ul className="list-disc pl-6 space-y-1 mt-2">
        <li>Chcesz mieć stałą, przewidywalną ratę</li>
        <li>Twoja zdolność kredytowa jest na granicy</li>
        <li>Wolisz niższą ratę na początku spłaty</li>
      </ul>

      <p className="mt-4">
        <strong>Wybierz raty malejące, jeśli:</strong>
      </p>
      <ul className="list-disc pl-6 space-y-1 mt-2">
        <li>Zależy Ci na jak najniższym koszcie kredytu</li>
        <li>Masz wystarczającą zdolność kredytową na wyższą pierwszą ratę</li>
        <li>Planujesz spłacać kredyt przez pełen okres bez nadpłat</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie</h2>
      <p>
        Jeśli priorytetem jest niższy całkowity koszt kredytu i stać Cię na wyższą ratę na początku —
        raty malejące są lepszym wyborem. Jeśli wolisz spokój i przewidywalność — raty równe
        będą wygodniejsze. W obu przypadkach warto rozważyć <BlogLink slug="nadplata-kredytu-hipotecznego">nadpłaty kredytu</BlogLink>, które mogą znacząco obniżyć
        koszt kredytu niezależnie od wybranego typu rat.
      </p>
      <p className="mt-3">
        Nieporównanie obu wariantów to jeden z 7 <BlogLink slug="najczestsze-bledy-kredyt-hipoteczny">najczęstszych błędów kredytobiorców</BlogLink>{' '}
        — może Cię kosztować nawet 120 000 zł niepotrzebnie zapłaconych odsetek
        w skali 25 lat.
      </p>

      <div className="mt-4">
        <CalculatorLink section="installment-type">
          Porównaj oba typy rat w kalkulatorze
        </CalculatorLink>
      </div>
    </>
  )
}
